var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ version: "1", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.5 14c-1.5 0-2.7.4-3.6.9 1.4 1.2 2 2.6 2.1 2.7l.1.2V20h8v-2c-.1 0-1.7-4-6.6-4z" }),
    React.createElement("circle", { cx: "16.5", cy: "8.5", r: "3.5" }),
    React.createElement(
      "g",
      null,
      React.createElement("path", { d: "M4 8.5C4 6.6 5.6 5 7.5 5S11 6.6 11 8.5 9.4 12 7.5 12 4 10.4 4 8.5zM7.5 14C2.6 14 1 18 1 18v2h13v-2s-1.6-4-6.5-4z" })
    )
  );
});


// WEBPACK FOOTER //
// ./src/static/images/icons/teleconnect.svg